import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { AlertTriangle } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{
          minHeight: '100vh',
          background: '#09090b',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 3,
          p: 4,
          textAlign: 'center'
        }}>
          <Box sx={{ color: '#ef4444', mb: 1 }}>
            <AlertTriangle size={48} />
          </Box>
          <Typography variant="h4" sx={{ color: '#fafafa', fontWeight: 700 }}>
            Something went wrong
          </Typography>
          <Typography sx={{ color: '#71717a', maxWidth: 420 }}>
            An unexpected error occurred. Please refresh the page or contact support if the issue persists.
          </Typography>
          <Button
            variant="contained"
            onClick={() => window.location.href = '/'}
            sx={{
              mt: 1,
              background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
              textTransform: 'none',
              fontWeight: 600,
              px: 4, py: 1.5,
              borderRadius: 2
            }}
          >
            Back to Home
          </Button>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
